import { useState } from "react";
import { Link } from "react-router-dom";
import { getPlatformIcon } from "@/components/shared/PlatformIcon";
import type { Platform } from "@/constants/platforms";

export type ExampleTheme = "all" | "recipes" | "tech" | "travel" | "nightlife" | "wellness" | "disney" | "family" | "shopping" | "fitness";

export type ExamplePost = {
  id: string;
  title: string;
  thumb: string;
  entities: string[];
  theme: ExampleTheme;
  platform: Platform;
};

export const EXAMPLE_POSTS: ExamplePost[] = [
  { id: "e8ff4e2e-cd4d-49ec-9b43-543c9718ba15", title: "Top 10 Disney World snacks to try", thumb: "https://d1k4z5if38476e.cloudfront.net/media/e8ff4e2e-cd4d-49ec-9b43-543c9718ba15/media_1.jpg", entities: ["Gaston\u2019s Tavern", "Tony\u2019s Town Square"], theme: "disney", platform: "instagram" },
  { id: "ced411f3-f261-4910-8aec-99dbd8710468", title: "Arrays in JavaScript Explained", thumb: "https://d1k4z5if38476e.cloudfront.net/media/ced411f3-f261-4910-8aec-99dbd8710468/media_0.jpg", entities: ["Arrays in JavaScript", "Developers Community"], theme: "tech", platform: "instagram" },
  { id: "77018f82-be73-4147-96ef-bc98d3be4176", title: "QC Spa New York\u2019s Candlelight Concerts", thumb: "https://d1k4z5if38476e.cloudfront.net/media/77018f82-be73-4147-96ef-bc98d3be4176/media_3.jpg", entities: ["Candlelight", "QC Spa New York"], theme: "wellness", platform: "facebook" },
  { id: "f687b776-edb9-4859-9ab0-74c905442997", title: "Top 5 White T-Shirts for Men", thumb: "https://d1k4z5if38476e.cloudfront.net/media/f687b776-edb9-4859-9ab0-74c905442997/media_1.jpg", entities: ["White T-Shirts", "Men\u2019s Fashion"], theme: "shopping", platform: "tiktok" },
  { id: "1314f109-848e-4f07-96fc-ac65063b3b2e", title: "San Juan de Gaztelugatxe, Spain", thumb: "https://d1k4z5if38476e.cloudfront.net/media/1314f109-848e-4f07-96fc-ac65063b3b2e/media_1.jpg", entities: ["San Juan de Gaztelugatxe"], theme: "travel", platform: "instagram" },
  { id: "03d3f21c-2393-470d-8596-6ad3d5c169ae", title: "Cheap Eats in Bay Area: Part 1", thumb: "https://d1k4z5if38476e.cloudfront.net/media/03d3f21c-2393-470d-8596-6ad3d5c169ae/media_1.jpg", entities: ["Cordon Bleu"], theme: "nightlife", platform: "instagram" },
  { id: "af2c0679-ad09-4599-923e-d5ad7e1fd0fa", title: "Save and Find Workouts with Stasht", thumb: "https://d1k4z5if38476e.cloudfront.net/media/af2c0679-ad09-4599-923e-d5ad7e1fd0fa/media_1.jpg", entities: ["Kettlebell Workout", "Stasht"], theme: "fitness", platform: "tiktok" },
  { id: "00d2b467-92f9-4425-9a7a-37056c76662f", title: "Top 10 Sandwiches in NYC", thumb: "https://d1k4z5if38476e.cloudfront.net/media/00d2b467-92f9-4425-9a7a-37056c76662f/thumb_0.jpg", entities: ["Salt Hank\u2019s", "Sal Chris and Charlie\u2019s"], theme: "nightlife", platform: "instagram" },
  { id: "b3ea13d2-2a3d-48b4-9ba8-aef51f2414db", title: "Family-friendly hotel in Braunwald, Switzerland", thumb: "https://d1k4z5if38476e.cloudfront.net/media/b3ea13d2-2a3d-48b4-9ba8-aef51f2414db/thumb_0.jpg", entities: ["M\u00e4rchenhotel Braunwald", "Braunwald"], theme: "family", platform: "instagram" },
  { id: "e98aee48-be60-474b-b194-cfdbb3025579", title: "Raspberry Cheesecake Bites Recipe", thumb: "https://d1k4z5if38476e.cloudfront.net/media/e98aee48-be60-474b-b194-cfdbb3025579/media_1.jpg", entities: ["Raspberry Cheesecake Bites"], theme: "recipes", platform: "instagram" },
  { id: "7cb4092f-e6d3-49a3-adc2-fc366ad46617", title: "BAPS Swaminarayan Akshardham: Largest Hindu Temple", thumb: "https://d1k4z5if38476e.cloudfront.net/media/7cb4092f-e6d3-49a3-adc2-fc366ad46617/media_1.jpg", entities: ["BAPS Swaminarayan Akshardham", "Robbinsville NJ"], theme: "travel", platform: "tiktok" },
  { id: "97c25511-2343-405e-9f5e-ef7a23fd293b", title: "Explaining Business Ideas Simply", thumb: "https://d1k4z5if38476e.cloudfront.net/media/97c25511-2343-405e-9f5e-ef7a23fd293b/media_1.jpg", entities: ["Michael Seibel", "Y Combinator"], theme: "tech", platform: "instagram" },
  { id: "f115dd42-1e9e-4dfb-9767-e7207919a0a4", title: "Onsen and dining in SF", thumb: "https://d1k4z5if38476e.cloudfront.net/media/f115dd42-1e9e-4dfb-9767-e7207919a0a4/media_0.jpg", entities: ["Onsen"], theme: "wellness", platform: "instagram" },
  { id: "139f2d85-8642-4aca-be49-20dd22f6aeef", title: "Garden of Laughs Comedy Event", thumb: "https://d1k4z5if38476e.cloudfront.net/media/139f2d85-8642-4aca-be49-20dd22f6aeef/media_0.jpg", entities: ["Radio City Music Hall", "Garden of Laughs"], theme: "nightlife", platform: "facebook" },
  { id: "4bf0b55d-02cc-4128-8040-07dfc8ec4207", title: "Praising Effort Over Traits in Kids", thumb: "https://d1k4z5if38476e.cloudfront.net/media/4bf0b55d-02cc-4128-8040-07dfc8ec4207/media_0.jpg", entities: ["Big Little Feelings"], theme: "family", platform: "instagram" },
  { id: "1a21adc5-4a72-4116-9344-77cf68856aaa", title: "Italian Porchetta Sandwich at Cortura", thumb: "https://d1k4z5if38476e.cloudfront.net/media/1a21adc5-4a72-4116-9344-77cf68856aaa/media_1.jpg", entities: ["Cortura", "Italian Porchetta Sandwich"], theme: "nightlife", platform: "instagram" },
  { id: "739b0af7-054e-4f6d-9968-c79ae1998511", title: "AI Emergent Behaviors Across Labs", thumb: "https://d1k4z5if38476e.cloudfront.net/media/739b0af7-054e-4f6d-9968-c79ae1998511/media_0.jpg", entities: ["Anthropic", "OpenAI", "Google DeepMind"], theme: "tech", platform: "twitter" },
  { id: "62f49a70-872e-40b6-baa0-89388f2256a1", title: "NYC Activities with Kids at Pier 57", thumb: "https://d1k4z5if38476e.cloudfront.net/media/62f49a70-872e-40b6-baa0-89388f2256a1/media_1.jpg", entities: ["Pier 57 Playground", "American Girl NYC"], theme: "family", platform: "instagram" },
  { id: "9b388784-67a1-41b5-aea2-bc763b32e338", title: "Renegade Tech Comedians Roast", thumb: "https://d1k4z5if38476e.cloudfront.net/media/9b388784-67a1-41b5-aea2-bc763b32e338/media_0.png", entities: ["Renegade Tech Comedians Roast"], theme: "nightlife", platform: "web" },
  { id: "60826c96-5cb8-4891-93a7-080b57b37c03", title: "AI-powered Python tool for web scraping", thumb: "https://d1k4z5if38476e.cloudfront.net/media/60826c96-5cb8-4891-93a7-080b57b37c03/media_0.png", entities: ["ScrapeGraphAI", "GitHub"], theme: "tech", platform: "twitter" },
];

export const THEME_LABELS: { value: ExampleTheme; label: string }[] = [
  { value: "wellness", label: "Wellness" },
  { value: "recipes", label: "Recipes" },
  { value: "tech", label: "Tech" },
  { value: "nightlife", label: "Nightlife" },
  { value: "travel", label: "Travel" },
  { value: "disney", label: "Disney" },
  { value: "family", label: "Family" },
  { value: "fitness", label: "Fitness" },
  { value: "shopping", label: "Shopping" },
];

type ExamplesSectionProps = {
  /** Cap the number of cards rendered. Useful on the invite landing preview. */
  limit?: number;
  /** Hide the theme filter pills. Paired with a small limit for preview grids. */
  hideFilters?: boolean;
};

export const ExamplesSection = ({ limit, hideFilters }: ExamplesSectionProps = {}) => {
  const [activeTheme, setActiveTheme] = useState<ExampleTheme | null>(null);

  const base = activeTheme
    ? EXAMPLE_POSTS.filter(p => p.theme === activeTheme)
    : EXAMPLE_POSTS;
  const filtered = typeof limit === "number" ? base.slice(0, limit) : base;

  return (
    <section className="flex items-start justify-center pt-3 pb-10 md:py-20 lg:py-28 relative w-full">
      <div className="page-frame">
        <div className="flex flex-col gap-8 md:gap-12">
          <div className="flex flex-col gap-4 items-center text-center">
            <h2 className="font-semibold leading-none text-display-28 sm:text-display-40 md:text-display-52 lg:text-display-64 tracking-[-0.84px] sm:tracking-[-1.2px] md:tracking-[-1.56px] lg:tracking-[-1.92px] text-foreground">
              See what others are <span className="text-brand-500">stashing</span>
            </h2>
            <p
              className="font-normal leading-normal max-w-[567px] text-base md:text-lg text-foreground/70"
              style={{ fontVariationSettings: "'opsz' 14" }}
            >
              Real stashes from real users, just like you.<br />Take a look around.
            </p>
          </div>

          {!hideFilters && (
            <div className="flex gap-2 overflow-x-auto pb-1 -mx-4 px-4 sm:mx-0 sm:px-0 sm:flex-wrap sm:justify-center scrollbar-hide">
              {THEME_LABELS.map(({ value, label }) => (
                <button
                  key={value}
                  type="button"
                  onClick={() => setActiveTheme(activeTheme === value ? null : value)}
                  className={`inline-flex items-center rounded-full font-medium whitespace-nowrap px-4 py-2 text-sm transition-colors shrink-0 ${
                    activeTheme === value
                      ? "bg-foreground text-background"
                      : "bg-muted text-foreground hover:bg-muted/80"
                  }`}
                >
                  {label}
                </button>
              ))}
            </div>
          )}

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
            {filtered.map(post => (
              <Link
                key={post.id}
                to={`/stash/${post.id}`}
                className="group relative aspect-[4/5] rounded-2xl overflow-hidden bg-muted"
              >
                <img
                  src={post.thumb}
                  alt={post.title}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/10 to-black/70" />
                <span className="absolute top-2.5 left-2.5 inline-flex items-center rounded-full bg-black/50 backdrop-blur-sm text-white text-xs font-medium px-2.5 py-1">
                  {THEME_LABELS.find(t => t.value === post.theme)?.label}
                </span>
                <div className="absolute top-3 right-3 z-10 flex items-center justify-center rounded-xl bg-black/50 dark:bg-black/60 border border-white/30 p-1.5">
                  {getPlatformIcon(post.platform, 14, true)}
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-3">
                  <h3 className="text-white text-sm font-semibold leading-tight line-clamp-2 drop-shadow-[0_1px_3px_rgba(0,0,0,0.8)]">
                    {post.title}
                  </h3>
                  {post.entities.length > 0 && (
                    <div className="flex flex-wrap gap-1 mt-1.5">
                      {post.entities.slice(0, 2).map(entity => (
                        <span
                          key={entity}
                          className="inline-flex items-center rounded-full bg-white/20 backdrop-blur-sm text-white/90 text-ui-badge font-medium px-2 py-0.5"
                        >
                          {entity}
                        </span>
                      ))}
                    </div>
                  )}
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
